import { publicUrl } from '../utils/publicUrl';

/**
 * Large GIFs/videos: keep files under `public/images/design-gallery/` and register them here.
 * Images in `src/assets/design-gallery` are picked up automatically by webpack.
 */
export const designGalleryPublicMedia = [
  {
    type: 'video',
    src: publicUrl('images/design-gallery/chessmaps-recording.mov'),
    alt: 'Chessmaps screen recording',
    hoverText: 'ChessMaps- map ui preview',
    loopStart: 2.5,
    loopEnd: 20,
  },
  {
    type: 'video',
    src: publicUrl('images/design-gallery/floatpos-recording.mov'),
    alt: 'Float Pos recording',
    size: 'large',
    hoverText: 'FloatPOS - all in one restaurant management and point of sale system',
  },
];
